import React, { useState } from "react";
import { Box, Alert, Tabs, Tab } from "@mui/material";

import DashboardLayout from "../../layouts/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";

import OverviewTab from "./Tabs/OverviewTab";
import CredentialsTab from "./Tabs/CredentialsTab";
import ShoppingTableTab from "./Tabs/ShoppingTable";
import SheetSettingsTab from "./Tabs/SheetSettings";
import ProfitTab from "./Tabs/ProfitTab";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);

const StatisticsPage = () => {
  // Utility function to safely convert error to string
  const getErrorMessage = (error) => {
    if (typeof error === "string") return error;

    // Handle axios error structure
    if (error.response?.data?.detail) {
      const detail = error.response.data.detail;
      if (typeof detail === "string") return detail;
      if (Array.isArray(detail)) {
        // Handle validation errors array
        return detail
          .map((err) =>
            typeof err === "string"
              ? err
              : err.msg
                ? `${err.loc?.join(".")} ${err.msg}`
                : JSON.stringify(err),
          )
          .join("; ");
      }
      return JSON.stringify(detail);
    }

    if (error.response?.data?.message) {
      return typeof error.response.data.message === "string"
        ? error.response.data.message
        : JSON.stringify(error.response.data.message);
    }

    if (error.message) {
      return typeof error.message === "string"
        ? error.message
        : JSON.stringify(error.message);
    }

    return JSON.stringify(error);
  };

  // Generall
  const [tabValue, setTabValue] = useState(0);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const METABASE_URL =
    import.meta.env.VITE_METABASE_URL || "https://metabase.lage-beauty.de/";
  const METABASE_TAB_INDEX = 5;

  const handleTabChange = (event, newValue) => {
    if (newValue === METABASE_TAB_INDEX) {
      window.open(METABASE_URL, "_blank", "noopener,noreferrer");
      return;
    }
    setTabValue(newValue);
    setError(null);
    setSuccess(null);
  };

  return (
    <DashboardLayout>
      <MDBox>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <MDTypography variant="h4" fontWeight="medium" color="dark" mb={3}>
          Statistics & Integrations
        </MDTypography>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Overview" />
            <Tab label="Credentials" />
            <Tab label="Sheet Settings" />
            <Tab label="Shopping Table" />
            <Tab label="Profits" />
            <Tab label="Metabase" />
          </Tabs>
        </Box>

        {/* Overview Tab */}
        <TabPanel value={tabValue} index={0}>
          <OverviewTab />
        </TabPanel>

        {/* Credentials Tab */}
        <TabPanel value={tabValue} index={1}>
          <CredentialsTab />
        </TabPanel>

        {/* Sheet Settings Tab */}
        <TabPanel value={tabValue} index={2}>
          <SheetSettingsTab />
        </TabPanel>

        {/* Shopping Table Management Tab */}
        <TabPanel value={tabValue} index={3}>
          <ShoppingTableTab />
        </TabPanel>

        {/* Profit Tab */}
        <TabPanel value={tabValue} index={4}>
          <ProfitTab />
        </TabPanel>
      </MDBox>
    </DashboardLayout>
  );
};

export default StatisticsPage;
